const initialState = {
  products: [],
  loading: false,
  error: null,
};

export const sellerProductViews = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SELLER_PRODUCT_VIEWS":
      return { products: action.payload, loading: false, error: null };
    case "GET_SELLER_PRODUCT_VIEWS_FAILURE":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};
